export const TYPE_HEADER = 'header'
export const TYPE_CONTENT_LIST = 'content-list'
export const TYPE_PEOPLE_LIST = 'people-list'
export const TYPE_PORTAL_LIST = 'portals'
export const TYPE_CONTENT_PEOPLE_LIST = 'content-people-list'
export const TYPE_LINK = 'link'
export const TYPE_PEOPLE = 'people'
export const TYPE_PORTAL = 'portals'
export const TYPE_CONTENT = 'content'
export const TYPE_CONTENT_PEOPLE = 'content-people'
export const TYPE_CONTENT_TAGS = 'content-tags'
export const TYPE_MERCH_PLACEMENT = 'placement'
export const TYPE_CONTENT_LABEL = 'content (videos, series & courses)'
export const TYPE_PORTAL_LABEL = 'portals'
export const TYPE_CONTENT_PEOPLE_LABEL = 'content (people)'
export const TYPE_CONTENT_TAGS_LABEL = 'content (tags)'
